import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';

declare var Chart;
declare var $;

@Component({
  selector: 'app-chart-donut',
  templateUrl: './chart-donut.component.html',
  styleUrls: ['./chart-donut.component.scss']
})
export class ChartDonutComponent implements OnInit {
  @Input() public element: string;
  @Input() public heightSize: number;
  @Input() public dataArray: any;
  @Input() public labelArray: any;
  @Input() public printing: boolean = false;
  @Output() public chartReady: EventEmitter<void> = new EventEmitter<void>();
  public myChart;
  constructor() {
  }
  ngOnInit() {
    setTimeout(() => {
      this.startChart();
    }, 200);
  }

  startChart() {
    if (this.myChart) {
      this.myChart.destroy();
    }
    this.myChart = new Chart(this.ctx(), {
        type: 'doughnut',
        data: this.data(),
        options: this.options()
    });
    this.chartReady.emit();
  }

  resizeChart() {
    if (this.myChart) {
      this.myChart.resize();
    }
  }

  data() {
    var gradientStroke = this.ctx().createLinearGradient(0, 500, 0, 150);
    gradientStroke.addColorStop(0, "#fa5c7c");
    gradientStroke.addColorStop(1, "#727cf5");
    return {
      labels: this.labelArray,
      datasets: [
          {
              data: this.dataArray,
              backgroundColor: [
                  "#727cf5",
                  "#fa5c7c",
                  "#0acf97",
                  "#ebeff2",
                  '#285e88',
                  '#771485',
                  '#925611',
                  '#a51635',
                  '#2937af',
                  '#47afa6',
              ],
              borderColor: "transparent",
              borderWidth: "3",
          }]
    };
  }

  options() {
    return {
      maintainAspectRatio: false,
      cutoutPercentage: 60,
      legend: {
          display: false
      }
    };
  }

  preCtx() {
    return this.input().get(0);
  }

  ctx() {
    return this.preCtx().getContext('2d');
  }

  input() {
      return $('#' + this.element);
  }

  setChartDraw() {
    var draw = Chart.controllers.line.prototype.draw;
      Chart.controllers.line.prototype.draw = function () {
          draw.apply(this, arguments);
          var ctx = this.chart.chart.ctx;
          var _stroke = ctx.stroke;
          ctx.stroke = function () {
              ctx.save();
              ctx.shadowColor = 'rgba(0,0,0,0.01)';
              ctx.shadowBlur = 20;
              ctx.shadowOffsetX = 0;
              ctx.shadowOffsetY = 5;
              _stroke.apply(this, arguments);
              ctx.restore();
          }
      };
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log('changes donas ', changes);
    setTimeout(() => {
      if (changes.printing && !changes.printing.firstChange) {
        this.resizeChart();
      } else {
        this.startChart();
      }
    }, 200);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/tools/charts/chart-donut/chart-donut.component.ts